module.exports = __webpack_public_path__ + "static/img/tc5.03d0d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/tc5.png
// module id = WW92
// module chunks = 1